/*------------------------------------*\
	#ANIMATION
\*------------------------------------*/

const initAnimationObserver = () => {
	if (!!window.IntersectionObserver) {

		/* For FADE Animation */
		let fadersArray = ['.section .o-wrapper'];
		/* TODO: nicht die Selektierung im js machen sondern im html markup Anhand von data-Attribute z.B. data-animate="fade"*/
		let fadersNodeList = [];

		if (fadersArray.length) {
			fadersArray.forEach(fader => {
				fadersNodeList.push(document.querySelectorAll(fader));
			})
		}

		/* For SLIDE Animation */
		let slidesArray = [];
		let slidesNodeList = [];

		if (slidesArray.length) {
			slidesArray.forEach(slide => {
				slidesNodeList.push(document.querySelectorAll(slide));
			})
		}

		const appearOptions = {
			threshold: 0,
			rootMargin: '200px 0px 0px 0px'
		};
		const appearOnScroll = new IntersectionObserver(function (entries, appearOnScroll) {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					// if not intersection in the page then return
					return;
				} else {
					//    do some think if intersect
					entry.target.classList.add('has-animation-' + 'appear');

					appearOnScroll.unobserve((entry.target));

				}
			})
		}, appearOptions)

		/* For FADE Animation */
		if (fadersNodeList.length) {
			fadersNodeList.forEach(faderList => {
				faderList.forEach(fader => {
					fader.classList.add('u-animation-slide','js-animation-fade')
					appearOnScroll.observe(fader);
				})
			})
		}

		/* For SLIDES Animation */
		if (slidesNodeList.length) {
			slidesNodeList.forEach(slideList => {
				slideList.forEach(slide => {
					slide.classList.add('u-animation-slide','js-animation-fade')
					appearOnScroll.observe(slide);
				})
			})
		}
	} else {
		console.warn('Your browser dont support IntersectionObserver')
		/* TODO: nicht initial alle animationen ausblenden sondern gleich animaiton-has-appear hinzufügen*/
	}
}

window.addEventListener('DOMContentLoaded', (event) => {
	initAnimationObserver();
});
